<template>
	<div class="navheader w-100 absolute" :class="{fixed:isFix}">
		<div class="ft16 h68 lh68 title center-block">
			<span class="pull-left color-white" @click="jumpIndex()">
				<router-link to="/">中国·智慧职安环保科技有限公司</router-link>
			</span>
			<item :oData="oData" class="pull-right"></item>
		</div>
	</div>
</template>

<script>
	import item from '../navHeader_item/index';
	import bus from '@/assets/js/bus';
	import './index.less';
	export default {
		name: 'navHeader',
		data() {
			return {
				oData: {
					children: [{
							name: '首页',
							path: "/"
						},
						{
							name: '关于我们',
							path: "/about"
						},
						// {
						// 	name: '公司产品',
						// 	path: '',
						// 	children: [{
						// 			name: '专业家云平台',
						// 			path: 'https://www.51zyj.com/'
						// 		},
						// 		//{ name: '管理解决方案',path:'https://www.51zyj.com//products'},
						// 		{
						// 			name: '专业家论坛',
						// 			path: 'http://bbs.51zyj.com/'
						// 		}
						// 	]
						// },
						// //{ name: '最新资讯' ,path:"/news"},
						// {
						// 	name: '人才招聘',
						// 	path: "/recruit"
						// },
						// // {
						// // 	name: '代理商招募',
						// // 	path: ''
						// // },
						// {
						// 	name: '在线商城',
						// 	path: '/onlineMall'
						// },
						// {
						// 	name: '登录',
						// 	path: '/login'
						// }
					]
				},
				isFix: false
			}
		},
		methods: {
			/*跳转首页*/
			jumpIndex() {
				bus.$emit('nav', 0)
			},
			handleScroll() {
				let scrollTop = $(window).scrollTop();
				console.log(scrollTop)
				this.isFix = true;
			}
		},
		components: {
			"item": item
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll)
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/navHeader/index.vue